import Preloader from '../../ui/components/ui/preloader';
import OfferCheckoutNotice, { OfferCheckoutNoticeStatus } from './components/offer-checkout-notice/offer-checkout-notice';
import OfferCheckoutView, { OfferCheckoutViewProps } from './components/offer-checkout-view/offer-checkout-view';
import { OfferCheckoutStatus } from './constants/offer-checkout-status.enum';
import { OfferCheckoutResponseDto } from './types/response';

export type OfferCheckoutPageState =
  | { status: OfferCheckoutStatus.LOADING }
  | { status: OfferCheckoutStatus.READY; offer: OfferCheckoutResponseDto }
  | { status: OfferCheckoutNoticeStatus };

export interface OfferCheckoutPageProps extends Required<Pick<OfferCheckoutViewProps, 'onSubmit' | 'validateBankDetails' | 'onDownloadOfferFile'>> {
  state: OfferCheckoutPageState;
}

/** Public checkout `/checkout/:token` – the offer, or a full-page notice instead. */
const OfferCheckoutPage = ({ state, onSubmit, validateBankDetails, onDownloadOfferFile }: OfferCheckoutPageProps) => {
  if (state.status === OfferCheckoutStatus.LOADING) {
    return (
      <main className="flex min-h-screen items-center justify-center bg-white">
        <Preloader />
      </main>
    );
  }

  if (state.status === OfferCheckoutStatus.READY) {
    // Desktop: full viewport height, both columns scroll on their own. Mobile: the page scrolls.
    return (
      <main className="min-h-screen bg-white p-4 lg:h-screen">
        <OfferCheckoutView
          offer={state.offer}
          termMonths={state.offer.termMonths}
          onSubmit={onSubmit}
          validateBankDetails={validateBankDetails}
          onDownloadOfferFile={onDownloadOfferFile}
        />
      </main>
    );
  }

  return <OfferCheckoutNotice status={state.status} />;
};

export default OfferCheckoutPage;
